import { render, staticRenderFns } from "./ReportProblemButton.vue?vue&type=template&id=6974188a&scoped=true"
import script from "./ReportProblemButton.vue?vue&type=script&lang=js"
export * from "./ReportProblemButton.vue?vue&type=script&lang=js"
import style0 from "./ReportProblemButton.vue?vue&type=style&index=0&id=6974188a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6974188a",
  null
  
)

export default component.exports